import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CTCustomizableChartDataService } from '@cloud-twin-v2/ct-dashboards/dashboard-chart/services/ct-customizable-chart-data.service';
import { CTCustomizableChartService } from '@cloud-twin-v2/ct-dashboards/dashboard-chart/services/ct-customizable-chart.service';
import { MaterialSharedModule } from '@common-modules/shared/material-shared.module';
import { GenericChartsModuleSettings } from '@common-modules/wlm-charts/generic-charts-module-settings';
import { GenericChartsModule } from '@common-modules/wlm-charts/generic-charts.module';
import { WlmSpinnerModule } from '@common-modules/wlm-spinner/wlm-spinner.module';
import { TranslateModule } from '@ngx-translate/core';
import { CTCustomizableChartComponent } from './chart/ct-customizable-chart/ct-customizable-chart.component';
import { CTChartConfigurationService } from './chart/services/ct-chart-configuration.service';
import { ResultsFiltrableItemService } from './filtrable-items/services/ct-result-filtrable-item.service';
import { TCGlobalsService } from './tc-globals.service';
import { TCRolesService } from './tc-roles.service';
import { TCSpinnerSplashService } from './tc-spinner-splash.service';

@NgModule({
  declarations: [CTCustomizableChartComponent],
  imports: [CommonModule, MaterialSharedModule, TranslateModule, WlmSpinnerModule,
    GenericChartsModule.forFeature(
      new GenericChartsModuleSettings({
        avoidConversion: true,
      }),
    ),],
  providers: [
    TCRolesService,
    TCGlobalsService,
    CTChartConfigurationService,
    { provide: 'CTChartConfigurationService', useExisting: CTChartConfigurationService },
    ResultsFiltrableItemService,
    TCSpinnerSplashService,
    { provide: 'SpinnerSplashService', useExisting: TCSpinnerSplashService },
    CTCustomizableChartDataService, CTCustomizableChartService
  ],
  exports: [CTCustomizableChartComponent],
})
export class CloudTwinSharedModule { }
